/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
export const CSR = "CSR";
/**
 * Customer service representative
 */
export const CSR_ROLE_ID = "-3";
/**
 * customer service supervisor
 */
export const CSS_ROLE_ID = "-4";
/*
 *  site administrator
 */
export const SITE_ADMIN_ID = "-1";
export const LIMIT = 10;
export const LIMIT_EXCEL = 999999999;
export const ZERO_OFFSET = 0;
export const FOR_USER_ID = "forUserId";
export const FOR_USER_SESSION = "forUserSession";
export const REGISTERED_CUSTOMER_ROLE = "-29";
export const STRING_ORGANIZATION_ROLE_ID = "organizationRoleId";
export const STRING_ROLE_ORGANIZATION_ID = "roleOrganizationId";
export const STRING_LIMIT = "limit";
export const STRING_OFFSET = "offset";
export const STRING_STORE_ID = "storeId";

export const COMMERCE_ENV = {
  defaultLang: "en_US",
  languageMap: {
    "-1": "en_US",
    "-2": "fr_FR",
    "-3": "de_DE",
    "-4": "it_IT",
    "-5": "es_ES",
    "-6": "pt_BR",
    "-7": "zh_CN",
    "-8": "zh_TW",
    "-10": "ja_JP",
    "-20": "ru_RU",
    "-21": "ro_RO",
  } as {
    [key: string]: string;
  },
  reverseLanguageMap: {
    en_US: "-1",
    fr_FR: "-2",
    de_DE: "-3",
    it_IT: "-4",
    es_ES: "-5",
    pt_BR: "-6",
    zh_CN: "-7",
    zh_TW: "-8",
    ja_JP: "-10",
    ru_RU: "-20",
    ro_RO: "-21",
  } as {
    [key: string]: string;
  },
};

export const REG_EX = {
  EMAIL: /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i,
  PHONE: /^[-+() ]*[0-9][-+() 0-9]*$/,
  ALPHA_NUMERIC_SPECIAL_CHAR: /^[a-zA-Z0-9 _.\-@]*$/,
  NUMERIC: /^[0-9]+$/,
};

export const EMPTY_STRING = "";

export const FORM_FIELD_PHONE = "phone";

export const CUSTOMER_FORM_FIELD_PHONE = "phone1";
export const FORM_FIELD_DATE_FROM = "dateFrom";
export const FORM_FIELD_DATE_TO = "dateTo";
export const FORM_FIELD_FIRST_NAME = "firstName";
export const FORM_FIELD_LAST_NAME = "lastName";
export const FORM_FIELD_LOGIN_ID = "loginID";

//constantes formulario reporte de clientes

export const FORM_FIELD_CUSTOMER_REPORT_DATE_FROM = "customerDateFrom";
export const FORM_FIELD_CUSTOMER_REPORT_DATE_TO = "customerDateto";

// constantes formulario de ordenes
export const FORM_FIELD_ORDER_STATUS = "orderStatus";
export const FORM_FIELD_ORDER_DATE_TO = "orderDateTo";
export const FORM_FIELD_ORDER_DATE_FROM = "orderDateFrom";
export const FORM_FIELD_ORDER_ID = "orderId";
//constantes comunes

export const FORM_FIELD_SALE_DATE_FROM = "saleDateFrom";
export const FORM_FIELD_SALE_DATE_TO = "saleDateTo";

//constantes formulario Productos Top

export const FORM_FIELD_TOP_PRODUCTS_DATE_FROM = "dateFrom";
export const FORM_FIELD_TOP_PRODUCTS_DATE_TO = "dateTo";
export const FORM_FIELD_TOP_PRODUCTS_TOP = "top";
export const FORM_FIELD_TOP_PRODUCTS_DISPLAY_OPTION = "displayOption";

//constantes formulario Productos y precios

export const FORM_FIELD_PRODUCT_PRICES_PRICE = "price";

//constantes formulario Clientes Top

export const FORM_FIELD_TOP_CLIENTS_DATE_FROM = "dateFrom";
export const FORM_FIELD_TOP_CLIENTS_DATE_TO = "dateTo";
export const FORM_FIELD_TOP_CLIENTS_TOP = "top";
export const FORM_FIELD_TOP_CLIENTS_SEARCH_BY = "searchBy";

//constantes formulario Reporte de inventario

export const FORM_FIELD_INVENTORY_CATALOG = "catalog";
export const FORM_FIELD_INVENTORY_CLASSIFICATION = "option";
export const FORM_FIELD_INVENTORY_PARAMETER = "parameter";
export const FORM_FIELD_INVENTORY_PARTNUMBER = "partnumber";

export const FORM_REQUIRED_FIELD_MESSAGE = "Complete este campo";

export const DAYS = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miercoles",
  "Jueves",
  "Viernes",
  "Sabado",
];

export const MONTHS = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

export const ADMIN_ROLE = "admin";
export const AVATAR_ADMIN_ROLE = "avatar-admin";
export const SELLER_ROLE = "seller";

export const API_URL = process.env.REACT_APP_API_URL;

export const PAGINATION_PAGE_SIZES = [10, 25];
